import config from '../../app/config';
import {useDispatch, useSelector} from 'react-redux';
import {getDocumentToPrev, getGroupId, setDocumentToPrev} from '../../store/reducers/documents';
import React, {useEffect, useRef, useState} from 'react';
import {loadImage} from '../../util/loaders';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import makeStyles from '@mui/styles/makeStyles';
import {sendOpenDocumentAudit} from '../../store/reducers/user';
import {patient} from '../../store/reducers/patient';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    prevContainer: {
        position: "fixed",
        zIndex: 99,
        height: "100%",
        width: "100%",
        top: "0",
        left: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#0000009e",
        flexDirection: "column",
        gap: 10
    },
    textClose: {
        color: "#eb0f0f",
        background: "#f5f5f582",
        padding: 5,
        fontSize: 12
    },
    backdrop: {
        zIndex: 9999
    }
}));

function ThumbnailPrev() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const imageElement = useRef(null);
  const document = useSelector(getDocumentToPrev);
  const [loading, setLoading] = useState(false);
  const patientObject = useSelector(patient);
  const {t} = useTranslation();

  const getImageUrlFull = () => {
    return `${config.imageDownloadURL}/${document.externalId}/preview/HI1?size=${config.modules.thumbnailPrev?.size || 500}`;
  };

  useEffect(async () => {
    if (document) {
      setLoading(true);
      loadImage(getImageUrlFull())
        .then((result) => {
          imageElement.current.setAttribute("src", result);
          let reportGroupId =
            document.metadata && document.metadata.reportGroupId
              ? document.metadata.reportGroupId
              : getGroupId(document);
          dispatch(
            sendOpenDocumentAudit(
              patientObject ? patientObject.hospitalNumber : "HOLDINGPEN",
              document.__id,
              reportGroupId,
            ),
          );
          setLoading(false);
        })
        .catch((ex) => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [document]);

  const leavePrev = () => {
    setLoading(false);
    dispatch(setDocumentToPrev(null));
  };

  return (
    <div onClick={leavePrev}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" size={64} />
      </Backdrop>

      {document && (
        <div className={classes.prevContainer}>
          <img height={"90%"} ref={imageElement} />
          <div className={classes.textClose}>{t('Click to close the preview')}</div>
        </div>
      )}
    </div>
  );
}

export default ThumbnailPrev;

